const settings = (state) => state.settings;
const setting = (state) => state.setting;

export default {
  settings,
  setting,
};
